// A person's or a team's initials, one way for every owner mark a workflow
// draws: the step card's avatar, the task form's owner cell, the diagram's
// owner chip and the run's planned assignee all read the same letters.
import React from "react";

/** Two letters: the first of each of two words, else the first two of
 * one; a question mark for no name. */
export const avatarInitials = (name: string): string => {
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  const letters =
    words.length >= 2
      ? `${words[0][0] ?? ""}${words[1][0] ?? ""}`
      : (words[0] ?? "").slice(0, 2);
  return letters.toUpperCase();
};

/** The 20 px round mark that holds a member's or a team's initials,
 * named for assistive tech by the name it stands for. */
export const InitialsMark: React.FC<{ name: string }> = ({ name }) => (
  <span
    role="img"
    aria-label={name}
    className="inline-flex h-[20px] w-[20px] flex-none items-center justify-center rounded-full bg-[#d8d5cd] text-[9px] font-semibold text-[var(--fp-ink-2)]"
  >
    {avatarInitials(name)}
  </span>
);
